import React from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { ReactComponent as TranslateIcon } from 'assets/translate.svg';

interface ContainerProps {
  disabled: boolean;
}

const Container = styled.button<ContainerProps>`
  ${({ theme: { colors }, disabled }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    border: none;
    background-color: transparent;
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
    transition: all 0.2s ease-in-out;
    position: relative;
    z-index: 0;

    &:hover:not(:disabled) {
      background-color: ${colors.primary.light}10;
    }

    &:active:not(:disabled) {
      background-color: ${colors.primary.light}20;
      transform: scale(0.95);
    }

    svg {
      width: 3rem;
      height: 3rem;
      color: ${disabled ? colors.neutral.grey : colors.primary.light};
      transition: color 0.2s ease-in-out;
    }
  `}
`;

interface ITranslationButton {
  onClick: () => void;
  disabled: boolean;
  showTranslation: boolean;
}

const TranslationButton: React.FC<ITranslationButton> = ({
  onClick,
  disabled,
  showTranslation,
}) => {
  return (
    <Container
      onClick={onClick}
      disabled={disabled}
      aria-label={showTranslation ? 'Hide translation' : 'Show translation'}
      aria-pressed={showTranslation}
      type="button"
    >
      <TranslateIcon />
    </Container>
  );
};

export default TranslationButton;